const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativityBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.2,299.86s-28.54-7.68-42-10.15-26.07-4.12-30.46,1.1-3.29,45.82-5.21,56-4.12,29.64-4.67,32.65-3,5.77-1.37,6.87,11.52,1.92,15.09,0,6.31-3,6.31-6.32.55-32.65,3-41.71,4.39-24.42,4.39-24.42,17.84,4.11,26.07,6.58,20,11.25,31.29,11.53,9.88-16.74,7.68-21.68S258.31,300.69,254.2,299.86Z",
    style: {
      fill: "#2F55D4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.31,246.14s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94,1,9.29-1.36,12.5-10.3,9.63-10.3,9.63-10.81-11-17.57-15-13.85-5.58-19.09,2.36-5.57,42.06-6.08,53.21-2.7,18.42-3.88,19.6a6.65,6.65,0,0,0-2,3.88c0,1-.17,3.38-.17,3.38s1.52,8.62,6.08,12,7.1,7.77,8.62,4.9,5.4-7.77,5.74-12A102.62,102.62,0,0,1,235.34,355c.51-2,.34-17.74,3.21-25.68s4.39-12.67,4.39-12.67,2.71,15.71,14.36,18.92,22.47-3,28.72-12.33,14.36-26.69,19.76-33.62,13.69-18.41,13.69-18.41l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10-11-14.87-16.21-22.3-5.58-13.35-10.82-15.21-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85Z",
    style: {
      fill: "#2F55D4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85l-6.42-.77s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94v.64l35.85,11.56c4.71-6.28,9.59-13,9.59-13l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10S337.54,270.73,332.31,263.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.69,209.67s-7.29,2.05-9.33,3.8-5,7.29-8.46,7.87-3.51,2.63-3.51,4.09a4.42,4.42,0,0,0,.59,2.33s-.29,6.71-.29,10.21.87,4.38,2.62,4.38h4.09s-.88,12.25-1.75,15.17,4.37-.29,5.83-1.75l8.17-8.17s-1.75-8.46.87-14.29-2-7.88-2.62-14.3A10.17,10.17,0,0,1,306.69,209.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.8,144.76S378,92.07,324.7,86.82s-88.28,35.62-126.2,57.61c-19.85,11.51-43.36,8.66-64.75,14.84C65.35,179,44.52,281.82,76.35,338c27.55,48.64,72.84,72.33,140.06,74.86s114.52,7.09,171.9-44.95S436.43,214.22,404.8,144.76Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8,144.76S378,92.07,324.7,86.82s-88.28,35.62-126.2,57.61c-19.85,11.51-43.36,8.66-64.75,14.84C65.35,179,44.52,281.82,76.35,338c27.55,48.64,72.84,72.33,140.06,74.86s114.52,7.09,171.9-44.95S436.43,214.22,404.8,144.76Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.51,220.41l12-1.41,1.82-13.29-11.27-4.61a53.52,53.52,0,0,0-2.26-12.81l9.19-8.15-6.13-11.93L382.79,171A53.11,53.11,0,0,0,366,156.85l.79-12.53L354,140.22l-6.68,10.72a52.59,52.59,0,0,0-12.66,0l-6.59-10.84-12.82,4,.68,12.68a53.36,53.36,0,0,0-10.39,7.16l-11.63-5.1-8.22,10.6,7.79,9.95a52.87,52.87,0,0,0-3.44,8.25c-.39,1.2-.72,2.42-1,3.63l-12.35,2.48-.66,13.4,11.91,3.66a53.37,53.37,0,0,0,3.18,12.44l-8.53,9,7.15,11.36,11.66-3.75a53.29,53.29,0,0,0,9.87,8.49l-1.77,12,12.37,5.2,7.31-9.6a52.71,52.71,0,0,0,13.1,1.28l5.41,10.74,13.11-2.83.49-12a53.65,53.65,0,0,0,11.48-6.53l10.57,5.68,9.11-9.84-6.47-10.11A53.52,53.52,0,0,0,391.51,220.41Zm-18.82-6.29A33.49,33.49,0,1,1,351,172,33.49,33.49,0,0,1,372.69,214.12Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,221.45l4.51-.53.68-5-4.23-1.73a20.46,20.46,0,0,0-.85-4.82l3.45-3.06-2.3-4.48-4.54,1a20,20,0,0,0-6.32-5.31l.29-4.71-4.79-1.54-2.52,4a19.87,19.87,0,0,0-4.75,0l-2.48-4.07-4.81,1.49.25,4.77a20.36,20.36,0,0,0-3.9,2.69l-4.37-1.92-3.09,4,2.93,3.74a19.85,19.85,0,0,0-1.3,3.1c-.14.45-.26.91-.38,1.37l-4.64.93-.24,5L98,217.81a19.75,19.75,0,0,0,1.2,4.68L96,225.87l2.68,4.26,4.39-1.4a20,20,0,0,0,3.71,3.19l-.67,4.52,4.65,2,2.74-3.61a19.7,19.7,0,0,0,4.92.48l2,4,4.92-1.07.19-4.5a20,20,0,0,0,4.31-2.45l4,2.13,3.43-3.7-2.44-3.79A20.44,20.44,0,0,0,137,221.45Zm-7.07-2.36a12.59,12.59,0,1,1-8.14-15.83A12.6,12.6,0,0,1,129.89,219.09Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.51,220.41l12-1.41,1.82-13.29-11.27-4.61a53.52,53.52,0,0,0-2.26-12.81l9.19-8.15-6.13-11.93L382.79,171A53.11,53.11,0,0,0,366,156.85l.79-12.53L354,140.22l-6.68,10.72a52.59,52.59,0,0,0-12.66,0l-6.59-10.84-12.82,4,.68,12.68a53.36,53.36,0,0,0-10.39,7.16l-11.63-5.1-8.22,10.6,7.79,9.95a52.87,52.87,0,0,0-3.44,8.25c-.39,1.2-.72,2.42-1,3.63l-12.35,2.48-.66,13.4,11.91,3.66a53.37,53.37,0,0,0,3.18,12.44l-8.53,9,7.15,11.36,11.66-3.75a53.29,53.29,0,0,0,9.87,8.49l-1.77,12,12.37,5.2,7.31-9.6a52.71,52.71,0,0,0,13.1,1.28l5.41,10.74,13.11-2.83.49-12a53.65,53.65,0,0,0,11.48-6.53l10.57,5.68,9.11-9.84-6.47-10.11A53.52,53.52,0,0,0,391.51,220.41Zm-18.82-6.29A33.49,33.49,0,1,1,351,172,33.49,33.49,0,0,1,372.69,214.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,221.45l4.51-.53.68-5-4.23-1.73a20.46,20.46,0,0,0-.85-4.82l3.45-3.06-2.3-4.48-4.54,1a20,20,0,0,0-6.32-5.31l.29-4.71-4.79-1.54-2.52,4a19.87,19.87,0,0,0-4.75,0l-2.48-4.07-4.81,1.49.25,4.77a20.36,20.36,0,0,0-3.9,2.69l-4.37-1.92-3.09,4,2.93,3.74a19.85,19.85,0,0,0-1.3,3.1c-.14.45-.26.91-.38,1.37l-4.64.93-.24,5L98,217.81a19.75,19.75,0,0,0,1.2,4.68L96,225.87l2.68,4.26,4.39-1.4a20,20,0,0,0,3.71,3.19l-.67,4.52,4.65,2,2.74-3.61a19.7,19.7,0,0,0,4.92.48l2,4,4.92-1.07.19-4.5a20,20,0,0,0,4.31-2.45l4,2.13,3.43-3.7-2.44-3.79A20.44,20.44,0,0,0,137,221.45Zm-7.07-2.36a12.59,12.59,0,1,1-8.14-15.83A12.6,12.6,0,0,1,129.89,219.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,127.52l3.87-.92.09-4.41-3.86-1.08A17.41,17.41,0,0,0,297,117l2.69-3-2.45-3.66-3.84,1.36a17.49,17.49,0,0,0-6-4l-.22-4.12-4.33-.86L281,106.51a17.81,17.81,0,0,0-4.14.46l-2.56-3.28-4,1.78.71,4.12a17.68,17.68,0,0,0-3.13,2.73l-4-1.22-2.28,3.77,2.92,3a17.29,17.29,0,0,0-.81,2.82c-.08.41-.14.82-.19,1.23l-3.94,1.28.29,4.4,4,.74a17.65,17.65,0,0,0,1.52,3.95l-2.45,3.26,2.77,3.44,3.66-1.67a17.71,17.71,0,0,0,3.55,2.4l-.12,4,4.24,1.23,2-3.42a16.92,16.92,0,0,0,4.33-.08l2.18,3.31,4.17-1.43-.29-3.93a17.62,17.62,0,0,0,3.5-2.57l3.67,1.45,2.6-3.56-2.5-3.06A17.81,17.81,0,0,0,298.09,127.52Zm-6.39-1.34A11,11,0,1,1,283,113.24,11,11,0,0,1,291.7,126.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.74,185.73s-9.11,20.8-7.74,22.06,11.9,21.72,13.62,21.79,1.12-5.32,1.12-5.32l10.19-9.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,173.13s19.79,11.14,19.46,13,3.55,24.51,2.21,25.6-4.09-3.58-4.09-3.58l-13.93-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,325.25c-10.64-30.34-43.9,15.53-60.82,26.22s-14-47-40.65-28.14-28,71.85-53.14,70.32c-10.76-.66-16.73-35.1-24.14-55.47l-35.6-143-19.07,8.37,46.74,141c2.29,12.07,15.64,44.26,14.95,51.05-.92,9-22.58,7.93-44,1-36-11.57-52.38-73.63-81-81.38-13.63-3.69-21.43,4.73-27,14.62q1.88,4.18,4.08,8.09c27.55,48.64,72.84,72.33,140.06,74.86s114.52,7.09,171.9-44.95q2.71-2.46,5.22-5.05C397.28,351.07,400.05,336.87,396,325.25Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,325.25c-10.64-30.34-43.9,15.53-60.82,26.22s-14-47-40.65-28.14-28,71.85-53.14,70.32c-10.76-.66-16.73-35.1-24.14-55.47l-35.6-143-19.07,8.37,46.74,141c2.29,12.07,15.64,44.26,14.95,51.05-.92,9-22.58,7.93-44,1-36-11.57-52.38-73.63-81-81.38-13.63-3.69-21.43,4.73-27,14.62q1.88,4.18,4.08,8.09c27.55,48.64,72.84,72.33,140.06,74.86s114.52,7.09,171.9-44.95q2.71-2.46,5.22-5.05C397.28,351.07,400.05,336.87,396,325.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,204.07s-6-63-10.84-80.47S147.77,81.5,138.3,85.68,124.8,123,127.17,140.21s29.09,74.51,37.48,80S189.07,227.33,189.77,204.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,204.07s0-.41-.11-1.18c-6.31,20.72-20.29,17.32-29.44,12.29a20.46,20.46,0,0,0,4.43,5C173,225.69,189.07,227.33,189.77,204.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,85.68c-8.84,3.91-12.93,33-11.52,50.83a31.11,31.11,0,0,0,11.23,6c16.1,4.7,33.19-4.25,40.48-20.32C172.65,104.81,147.52,81.61,138.3,85.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3,100.17a98.58,98.58,0,0,1,17,23.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.49,92s1.72,1.36,4.36,3.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6,
    y1: 200.48,
    x2: 186.99,
    y2: 203.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.41,
    y1: 191.47,
    x2: 186.29,
    y2: 198.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.56,
    y1: 139.73,
    x2: 184.63,
    y2: 185.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.25,
    y1: 129.88,
    x2: 177.8,
    y2: 134,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.69,
    y1: 158.31,
    x2: 146.97,
    y2: 183.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.14,
    y1: 186.9,
    x2: 150.45,
    y2: 192.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.93,
    cy: 162.51,
    rx: 15.01,
    ry: 14.18,
    transform: "translate(-39.42 272.45) rotate(-73.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,166.48a9.07,9.07,0,1,1-6-11.74A9.34,9.34,0,0,1,171.08,166.48Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.87,201.32l10.82,27.84a1.18,1.18,0,0,0,1.59.73h0a1.38,1.38,0,0,0,.72-1.73l-9.24-28.54a2,2,0,0,0-2.8-1.09h0A2.34,2.34,0,0,0,171.87,201.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-131"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 346.83,
    y1: 128.44,
    x2: 348.69,
    y2: 131.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.51,
    y1: 128.59,
    x2: 353.85,
    y2: 130.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.12,
    y1: 127.24,
    x2: 359.79,
    y2: 130.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.59,
    y1: 142.39,
    x2: 374.79,
    y2: 143.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.96,
    y1: 137.57,
    x2: 372.33,
    y2: 138.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.49,
    y1: 131.79,
    x2: 368.44,
    y2: 134.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.07,133.79h0l-.09,0-.08,0h0c-9.08-3.79-18.9.11-22.62,8.6a16.87,16.87,0,0,0-1.4,8.05c0,1.4-.08,4.82-.53,9.08a45.56,45.56,0,0,1-1.59,8.18l-.08.15a1.28,1.28,0,0,0,.64,1.72l.08,0,7,3.06.08,0,1.88.82.09,0,7,3.06.08,0a1.27,1.27,0,0,0,1.69-.69c0-.06.05-.11.07-.16a45.35,45.35,0,0,1,4.94-6.71c2.84-3.21,5.3-5.58,6.32-6.53a17,17,0,0,0-3.4-28.7Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.41,
    y: 172.77,
    width: 18.32,
    height: 4.25,
    transform: "translate(99.5 -124.2) rotate(23.71)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.13 185.01 352.7 181.45 335.92 174.08 334.4 177.54 351.13 185.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.35,
    y: 176.8,
    width: 18.32,
    height: 1.01,
    transform: "translate(100.38 -123.57) rotate(23.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.4 177.54 336.55 182.52 345.96 186.62 351.13 185.01 334.4 177.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,169.3a31.65,31.65,0,0,1,6.55-7.31c6.41-5.07,10.88-10,7.2-19.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,174.74s.38-.93,1.15-2.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,171.43s1.93-12.31.6-15.74-2.38,6.74,2.57,5.33,2.39-7.42,1.68-4.7,1.13,6.26,4.09,4.56,3.09-4.27,1.35-3.14.35,6.1,3.2,4.92,2.23-2.81.12-1.89-6.78,10.06-8.18,13.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-tube--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.39,254.19a18.08,18.08,0,0,1-4.19,6c-3.15,3.11-4.46,10.14,4.1,14s5.14,18.56-5.12,16.78-16.08-18-25.74-13.94-7,19.13-14.17,16.17-10.17-10-15.82-7.27-8.18,16,13.27,23.72,16.63-24.42,23.38-23.29,7.26,10.87,18,13.75,21.43-12.75,19.93-21.55-13.28-8.8-15.22-13.18,4.77-9.42,4.77-9.42S421.21,252.83,418.39,254.19Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.59,246.7,417,253.22a2.7,2.7,0,0,0,.9,3.18h0a2.71,2.71,0,0,0,3.7-.46l5.17-6.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.85,207.42l16.57,11.67S440.28,233.88,436.58,241s-8.83,12.09-13.08,11.36-6.79-6.66-5.53-11.75,10.48-16.54,12.37-22S433.85,207.42,433.85,207.42Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.85,207.42s-1.61,5.66-3.51,11.13a35.23,35.23,0,0,1-3.3,6.26A80.63,80.63,0,0,0,440,235.08c4.45-7.26,10.44-16,10.44-16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,263.37a2.66,2.66,0,1,1-.82-3.66A2.64,2.64,0,0,1,431,263.37Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.08,277.91a2.32,2.32,0,1,1-.72-3.21A2.33,2.33,0,0,1,408.08,277.91Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,315.74a1.16,1.16,0,1,1-2-1.24,1.16,1.16,0,1,1,2,1.24Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,301.48a24.62,24.62,0,0,0,8.85,3.42c9,1.51,10.12-3.56,12-10.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.93,296.64a20.92,20.92,0,0,0,2,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.69,296.9s9.54,4.35,15.44-7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.34,249.14a3.78,3.78,0,0,1-1.75-2.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,236.9s-5.89,11.33-9.63,12.76a6.16,6.16,0,0,1-2.66.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Photos--inject-131"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.67,
    y: 148.8,
    width: 27.86,
    height: 21.91,
    transform: "translate(-16.46 25.63) rotate(-6.41)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.67,
    y: 148.8,
    width: 27.86,
    height: 21.91,
    transform: "translate(-16.46 25.63) rotate(-6.41)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.89,
    y: 149.7,
    width: 25.31,
    height: 19.71,
    transform: "translate(-16.44 25.63) rotate(-6.41)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,155.12c-1.37-1.46-2.52-1.77-3.85-.2-2,2.39-3.08,7.73-4.5,7.51s-1.67-2.36-3.1-3.73-3.23,1.89-6.75,5.73a16.44,16.44,0,0,1-6,4.16l.26,2.35,25.41-2.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,155.13a3.23,3.23,0,1,1-3.57-2.84A3.23,3.23,0,0,1,216.39,155.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.07,
    y: 251.03,
    width: 48.83,
    height: 38.39,
    transform: "translate(91.88 -27.36) rotate(18.38)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.07,
    y: 251.03,
    width: 48.83,
    height: 38.39,
    transform: "translate(91.88 -27.36) rotate(18.38)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.37,
    y: 252.59,
    width: 44.36,
    height: 34.54,
    transform: "matrix(0.95, 0.32, -0.32, 0.95, 91.77, -27.4)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,271.93c-1.1-3.33-2.71-4.67-6-3.15-5,2.32-10.59,10-12.69,8.64s-.92-5-2.19-8.21-6.52.64-14.94,4.16a29,29,0,0,1-12.66,2.19l-1.3,3.92,42.54,14.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.18,259.78a5.66,5.66,0,1,1-3.59-7.16A5.66,5.66,0,0,1,127.18,259.78Z",
    style: {
      fill: "#2F55D4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--music-icons--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.24,346.44a1.93,1.93,0,0,0-1.8-2.53l-21.23-.48a2,2,0,0,0-1.89,1.34L348.19,367a5.79,5.79,0,0,0-1.92-1.06,6,6,0,1,0,3.67,8l.08,0L355.46,357l17.19.39-3.15,9.8a6,6,0,1,0,2,6.51s0-.06,0-.09Zm-6.36,7.13-17.19-.39,1.88-5.85,17.19.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,360.46a.86.86,0,0,0-.12-.76.88.88,0,0,0-.68-.36l-9.38-.21a.86.86,0,0,0-.84.59l-3.15,9.82a2.61,2.61,0,0,0-.85-.47,2.65,2.65,0,1,0,1.62,3.55h0l2.41-7.49,7.6.17-1.39,4.34a2.5,2.5,0,0,0-.83-.46,2.65,2.65,0,1,0,1.71,3.34s0,0,0,0Zm-2.81,3.15-7.6-.17.83-2.59,7.6.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,313.75a.83.83,0,0,0-.11-.73.87.87,0,0,0-.66-.35l-9.11-.21a.83.83,0,0,0-.81.58l-3.06,9.52a2.61,2.61,0,0,0-.82-.45,2.57,2.57,0,1,0,1.57,3.44h0l2.33-7.26,7.37.16-1.35,4.21a2.27,2.27,0,0,0-.81-.44,2.57,2.57,0,1,0,1.66,3.23.06.06,0,0,0,0,0ZM139,316.81l-7.37-.16.8-2.51,7.38.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.07,197.6c47.42,10.44,139.59,38.42,163.12,40,57.53,4,61-97.24-14.19-119.87-58.6-17.64-117.12,27.48-164.06,44.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      strokeDasharray: "3,3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,314.05c21.88-16.52,71.79-42.77,166.37-40.43,105.41,2.6,143.84,19.2,190.55,19.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      strokeDasharray: "5,3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,409.8s-27.42,6.88-101.12-15.67c-32.82-10.05-66.57-27.49-84.69-57.86-28.49-47.75-14.42-113,32.89-136.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      strokeDasharray: "5,3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.49 399.73 267.34 431.44 352.16 414.97 274.49 399.73",
    style: {
      fill: "#263238",
      stroke: "#2F55D4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.59 408.87 267.34 431.44 297.98 424.88 274.59 408.87",
    style: {
      fill: "#263238",
      stroke: "#2F55D4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.93 374.34 274.49 399.73 352.16 414.97 272.93 374.34",
    style: {
      fill: "#263238",
      stroke: "#2F55D4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.16 414.97 274.04 442.69 274.59 408.87 352.16 414.97",
    style: {
      fill: "#263238",
      stroke: "#2F55D4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.65,215.8s-4.38-8.75-2.34-13.71,9.92-12.84,14-9.63,2.62,10.5,6.12,12.55,14.88,7.29,15.76,17.21-6.71,17.5-4.67,21,17.21,2.63,23.34,12.55,4.08,23.92-.29,29.47-30.93,14-30.93,20.42,8.17,13.42-4.08,19.83-30.63,3.21-32.38-12,16.62-29.46,15.46-39.67-11.67-17.8-14.59-27.43,12.84-12.54,15.17-16S297.65,215.8,297.65,215.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,273.77c-.73,2.28-1.76,3.67-2.17,3.81",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.94,225.1s1.26,6.64,6.32,9.48-3.79,9.49,1.58,16.44,22.45,0,26.56,9.48a20.24,20.24,0,0,1,1.71,7.52",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,232.25a12.72,12.72,0,0,0,3,1.38",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,204.86s.32,15.5,5.06,21.5a27.13,27.13,0,0,0,3.2,3.43",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.26,208.4s1.64-6.67,1.64-8.61-.49-2.43-1-1.34a36.26,36.26,0,0,0-1.21,4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.77,385.48s-5.49,9.06-10.15,14-6,10.15-1.1,11.52,12.35-.55,16.19-4.39,7.14-9.6,11-11.8,6.31-2.47,6.31-8.5-2.74-7.41-2.74-7.41S179.28,385.21,170.77,385.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,394.54c-5.21,4.39-9.61,12.62-18.11,13.72-5,.64-8-.6-9.63-1.74-.33,2.12.55,3.79,3,4.48,4.94,1.38,12.35-.55,16.19-4.39s7.14-9.6,11-11.8c3.36-1.92,5.67-2.37,6.2-6.5A78.66,78.66,0,0,0,184.22,394.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,299.86s-28.54-7.68-42-10.15-26.07-4.12-30.46,1.1-3.29,45.82-5.21,56-4.12,29.64-4.67,32.65-3,5.77-1.37,6.87,11.52,1.92,15.09,0,6.31-3,6.31-6.32.55-32.65,3-41.71,4.39-24.42,4.39-24.42,17.84,4.11,26.07,6.58,20,11.25,31.29,11.53,9.88-16.74,7.68-21.68S258.31,300.69,254.2,299.86Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-131)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.28,313.42a42.77,42.77,0,0,0-4.69-7.21c-2.08-2.09-5.06-4.88-6.72-6.44l-3.64-1-11.3.94s-44.83-10.64-46-5.7,1.52,10.26,1.52,10.26-9.5-9.88-8.36-6.08,8.36,12.16,8.36,12.16-7.6-8.74-7.6-3.42,2.28,30.77-1.9,50.91c-2.75,13.22-8.11,23.17-10,29.41,3.62.34,8.34.22,10.58-1,3.57-1.93,6.31-3,6.31-6.32s.55-32.65,3-41.71,4.39-24.42,4.39-24.42,17.84,4.11,26.07,6.58,20,11.25,31.29,11.53C266.14,332.2,266.66,320.18,265.28,313.42Z",
    style: {
      opacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.31,313.86s1.21-12.27-6.35-19.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37,295.28s2.88,2.8,1.91,10.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,299.86s-28.54-7.68-42-10.15-26.07-4.12-30.46,1.1-3.29,45.82-5.21,56-4.12,29.64-4.67,32.65-3,5.77-1.37,6.87,11.52,1.92,15.09,0,6.31-3,6.31-6.32.55-32.65,3-41.71,4.39-24.42,4.39-24.42,17.84,4.11,26.07,6.58,20,11.25,31.29,11.53,9.88-16.74,7.68-21.68S258.31,300.69,254.2,299.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,246.14s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94,1,9.29-1.36,12.5-10.3,9.63-10.3,9.63-10.81-11-17.57-15-13.85-5.58-19.09,2.36-5.57,42.06-6.08,53.21-2.7,18.42-3.88,19.6a6.65,6.65,0,0,0-2,3.88c0,1-.17,3.38-.17,3.38s1.52,8.62,6.08,12,7.1,7.77,8.62,4.9,5.4-7.77,5.74-12A102.62,102.62,0,0,1,235.34,355c.51-2,.34-17.74,3.21-25.68s4.39-12.67,4.39-12.67,2.71,15.71,14.36,18.92,22.47-3,28.72-12.33,14.36-26.69,19.76-33.62,13.69-18.41,13.69-18.41l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10-11-14.87-16.21-22.3-5.58-13.35-10.82-15.21-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-131)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,319.13s-8.74-19-23.56-29.64-14.82-8-14.06-5.7,1.52,5.32,1.52,5.32-5.7-6.08-5.7-1.9,5.32,16.72,1.52,32.3-8,30.39-6.84,37.23,2.66,12.54-1.52,8-6.46,0-6.08,1.9c.16.77,4,5.28,8.74,10.51,1.78-2.91,4.65-7,4.94-10.62A102.62,102.62,0,0,1,235.34,355c.51-2,.34-17.74,3.21-25.68s4.39-12.67,4.39-12.67,2.71,15.71,14.36,18.92,22.47-3,28.72-12.33c2.69-4,5.72-9.5,8.73-15l-14,6.31Z",
    style: {
      opacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1,287.68s5.86,10,.58,26.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.45,286.51s1.91,6.86,0,12.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,246.14s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94,1,9.29-1.36,12.5-10.3,9.63-10.3,9.63-10.81-11-17.57-15-13.85-5.58-19.09,2.36-5.57,42.06-6.08,53.21-2.7,18.42-3.88,19.6a6.65,6.65,0,0,0-2,3.88c0,1-.17,3.38-.17,3.38s1.52,8.62,6.08,12,7.1,7.77,8.62,4.9,5.4-7.77,5.74-12A102.62,102.62,0,0,1,235.34,355c.51-2,.34-17.74,3.21-25.68s4.39-12.67,4.39-12.67,2.71,15.71,14.36,18.92,22.47-3,28.72-12.33,14.36-26.69,19.76-33.62,13.69-18.41,13.69-18.41l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10-11-14.87-16.21-22.3-5.58-13.35-10.82-15.21-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85l-6.42-.77s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94v.64l35.85,11.56c4.71-6.28,9.59-13,9.59-13l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10S337.54,270.73,332.31,263.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-131)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a31.93,31.93,0,0,1-4.75-.59s0,.08,0,.13,3.33,2.49,11.37,5.27,19.13,22.74,23.29,27.17,5.55,6.94,4.44,8.32-3.33,2.78-7.49,7.21c-2.72,2.91-6.26,6.29-7.77,9.75a60.4,60.4,0,0,0,17.21-9.46c5.58-4.73,6.59-6.75,4.39-10S337.54,270.73,332.31,263.3Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,243.14a38.21,38.21,0,0,1-12.2-6.38c-6.65-5-16.36-11.93-14.14-6.93s17.47,17.47,23.57,20.52,10,1.38,17.75.83,6.1-4.44,1.11-4.44S268.42,244.8,264.53,243.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,243.14a38.21,38.21,0,0,1-12.2-6.38c-6.65-5-16.36-11.93-14.14-6.93s17.47,17.47,23.57,20.52,10,1.38,17.75.83,6.1-4.44,1.11-4.44S268.42,244.8,264.53,243.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a31.93,31.93,0,0,1-4.75-.59s0,.08,0,.13,3.33,2.49,11.37,5.27,19.13,22.74,23.29,27.17,5.55,6.94,4.44,8.32-3.33,2.78-7.49,7.21c-2.72,2.91-6.26,6.29-7.77,9.75a60.4,60.4,0,0,0,17.21-9.46c5.58-4.73,6.59-6.75,4.39-10S337.54,270.73,332.31,263.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85l-6.42-.77s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34-32.09-20.71-35.59-23.34L228.8,217s.46-5.53.46-8.57-.17-5.92-.17-5.92.85-6.92.17-8.11-1.86.34-1.86,1.69a34.94,34.94,0,0,1-1.86,7.27s-1.18-7.1-1.52-8.45-1.18-1.86-2-1.52.17,4.06.17,5.58-.17,5.91-.17,5.91-3-7.43-3.89-8.95-1.86-.34-1.69,1,2.7,8.78,2.7,8.78-1.52,7.94-1.52,8.45-3.21-.51-4.73-1.86-2,0-1,1.69,3.72,3.38,6.76,4.73,6.42,2.7,6.42,2.7,17.57,18.92,24,24.84,13.52,9.62,17.24,11.65,11.82,6.25,11.82,6.25-4.05,3-4.05,7.94v.64l35.85,11.56c4.71-6.28,9.59-13,9.59-13l12,16.05a49.26,49.26,0,0,1-3.21,5.91c-2,3.21-8.78,9.46-8.78,9.46s3,2.36,5.4,2.7,13.69-5.07,19.26-9.8,6.59-6.75,4.39-10S337.54,270.73,332.31,263.3Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,263.3c-5.24-7.44-5.58-13.35-10.82-15.21s-11.65-.33-13.68-.33a42.06,42.06,0,0,1-6.08-.85l-6.42-.77s-2.62.59-10.21-.87-7.29,1.75-17.21-2.34c-.6-.25-1.25-.54-1.94-.88-2.68,2-5.61,5.52-7.3,11.47,3,1.92,5.75,3.36,7.61,4.37,3.71,2,11.82,6.25,11.82,6.25s-4.05,3-4.05,7.94,1,9.29-1.36,12.5c-1.81,2.46-6.88,6.8-9.16,8.69,4,3.69,16,15.67,21,32,.51-.65,1-1.32,1.47-2,6.25-9.29,14.36-26.69,19.76-33.62s13.69-18.41,13.69-18.41l4.46,6c3.17-3.77,7.19-7.19,12.12-8.69C334.71,266.67,333.42,264.88,332.31,263.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,273.21a23.45,23.45,0,0,0-2.11,1.57A16.21,16.21,0,0,1,294,278.85c-11.78-.76-17.86-9.88-18.24-6.84s0,11.4,6.84,14.06,15.58-.76,12.92,2.28-15.51,10-12.47,14.18,11.23,3.11,21.37-14.88c1.49-2.64,8.64-9.86,8.69-13.23C313.19,270.89,310.64,271.89,308.61,273.21Z",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,251.2c1.64.75,3.71,1.6,6.25,2.48,4.07,1.4,8.9,7.18,13.23,13.14a23.13,23.13,0,0,1,4.5-2.6c-5.11-7.35-5.49-13.17-10.68-15-3.95-1.4-8.57-.88-11.47-.54Z",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.16,264.5a19.19,19.19,0,0,0-11.84,9.22l2.61,3.49c3.17-3.77,7.19-7.19,12.12-8.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.73,246.91l-6.42-.77a17.92,17.92,0,0,1-4.92-.07c-.87,3.8-2.34,10.25-3.11,14.11-1.14,5.72,5,4.19,11.07,0,3.92-2.7,7.22-8.4,9.37-12.43A43.17,43.17,0,0,1,301.73,246.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,255.3c1.3-3.19,3.9-8.26,8.32-11.58-.63-.23-1.3-.49-2-.79s-1.25-.54-1.94-.88c-2.68,2-5.61,5.52-7.3,11.47C259.68,254.17,260.67,254.76,261.6,255.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,209.67s-7.29,2.05-9.33,3.8-5,7.29-8.46,7.87-3.51,2.63-3.51,4.09a4.42,4.42,0,0,0,.59,2.33s-.29,6.71-.29,10.21.87,4.38,2.62,4.38h4.09s-.88,12.25-1.75,15.17,4.37-.29,5.83-1.75l8.17-8.17s-1.75-8.46.87-14.29-2-7.88-2.62-14.3A10.17,10.17,0,0,1,306.69,209.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-131)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.65,247.6s-1.75-8.46.87-14.29-2-7.88-2.62-14.3a10.54,10.54,0,0,1,0-1.11,12.77,12.77,0,0,0-2.59,7.93c.38,5.34-1.15,11.45-4.58,13-2.45,1.08-7.79,1.78-9.43,2.51a2.11,2.11,0,0,0,2.06,1h4.09s-.12,1.65-.32,3.89c2.44,2.08,5.14,4.6,7.28,6.65Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.65,247.6s-1.75-8.46.87-14.29-2-7.88-2.62-14.3a10.54,10.54,0,0,1,0-1.11,12.77,12.77,0,0,0-2.59,7.93c.38,5.34-1.15,11.45-4.58,13-2.45,1.08-7.79,1.78-9.43,2.51a2.11,2.11,0,0,0,2.06,1h4.09s-.12,1.65-.32,3.89c2.44,2.08,5.14,4.6,7.28,6.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,209.67s-7.29,2.05-9.33,3.8-5,7.29-8.46,7.87-3.51,2.63-3.51,4.09a4.42,4.42,0,0,0,.59,2.33s-.29,6.71-.29,10.21.87,4.38,2.62,4.38h4.09s-.88,12.25-1.75,15.17,4.37-.29,5.83-1.75l8.17-8.17s-1.75-8.46.87-14.29-2-7.88-2.62-14.3A10.17,10.17,0,0,1,306.69,209.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.05,221.78c-.61,1-1.45,1.56-1.88,1.29s-.3-1.28.3-2.26,1.45-1.56,1.89-1.29S296.65,220.8,296.05,221.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.42,217.12s3.71-1.62,3,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94,229.22c-3.47,1.16-4.86,0-4.86,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.34,229.63v2.9s1.45,1.33,2.9-3.14A6.89,6.89,0,0,1,289.34,229.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,230.68s8.46-2.33,7.29,1.46-8.17,6.42-9,3.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.37,294.21s12.39,15.46,13.86,28.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,264.14s2.54-4.9,2.54-8.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.47,
    y1: 271.24,
    x2: 313.17,
    y2: 263.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,287.29a10.94,10.94,0,0,1,9.27-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.25,296.74a35.31,35.31,0,0,0-4.4-6.19c-2.12-2.12-7.82-1.79-8.47-.32s3.26,1.14,5.7,3.58,2.12,4.56,2.12,4.56a15.66,15.66,0,0,1-6.85,1c-3.09-.49-7.17-1.3-7.49-.16s.81,2.44,3.42,3.09,5.7.49,6.68.65,3.42,2.77,5.38,2.77,4.4-.48,5.05,0,2.44,2.77,4.4,2.77,3.75-2,3.91-4.23-1.14-4.4-3.91-5.54S322.25,296.74,322.25,296.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,296.91s-6.5-5.56-8.09-5.72-6.29,2.79-5.21,4,2.73-.57,4.18-.36,5.31,3.55,6,3.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,299.51l-2-3.26s-2.12,3.59-4.56,3.1,2.77-5.87,3.91-6.19,2.61-1,3.91,1.46a29.6,29.6,0,0,1,2.12,6.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,302.45s-.82-5.22-1.8-5.87-4.07.49-5.37,2-.49,1.79,1.14,1.79a3.54,3.54,0,0,0,2.44-.82l1.14,2.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,377.73a58.07,58.07,0,0,0-7.49-12.85C216.84,359,209,356.71,204,353.5s-12.25-7.58-15.46-3.79-.29,9,5,14.88,14.58,10.5,15.46,11.67,9.16,10.92,12.37,11.21S227.83,383.56,229,377.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,384c-1.67-5.93-7.74-10.95-11.9-14.12-5-3.77-8.23-9.06-17.29-15.92-3.94-3-6.69-4.15-8.53-4.51a3,3,0,0,0-.32.3c-3.21,3.79-.29,9,5,14.88s14.58,10.5,15.46,11.67,9.16,10.92,12.37,11.21C223.2,387.64,225.09,386.27,226.58,384Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.22,371.82c-5.75-4.79-18.52-19.17-21.4-20.44-2.4-1.07-3.35,1.53-3.6,2.42.24,3.15,2.72,6.83,6.28,10.79,5.25,5.83,14.58,10.5,15.46,11.67s9.16,10.92,12.37,11.21a1.6,1.6,0,0,0,1.91-1C224.84,384.11,218,376.61,212.22,371.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativityBro);
export default __webpack_public_path__ + "static/media/Creativity-bro.526548cf405037650f44e12b9966c682.svg";
export { ForwardRef as ReactComponent };